import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-success-modal',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule],
  template: `
    <div class="success-modal">
      <div class="modal-header">
        <h2 class="modal-title">{{ data.title || 'Éxito' }}</h2>
      </div>

      <div class="modal-content">
        <div class="icon-container">
          <mat-icon class="success-icon">check_circle</mat-icon>
        </div>
        <p class="message">{{ data.message }}</p>
      </div>

      <div class="modal-actions">
        <button mat-raised-button class="close-button" (click)="onClose()">Aceptar</button>
      </div>
    </div>
  `,
  styles: [
    `
      .success-modal {
        background: white;
        border-radius: 8px;
        overflow: hidden;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
        min-width: 400px;
        max-width: 500px;
      }

      .modal-header {
        background: #4caf50;
        color: white;
        padding: 16px 20px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);

        .modal-title {
          margin: 0;
          font-size: 18px;
          font-weight: 600;
        }
      }

      .modal-content {
        padding: 24px 20px;
        text-align: center;

        .icon-container {
          margin-bottom: 16px;

          .success-icon {
            font-size: 48px;
            width: 48px;
            height: 48px;
            color: #4caf50;
          }
        }

        .message {
          margin: 0;
          font-size: 16px;
          line-height: 1.5;
          color: #333;
          font-weight: 500;
        }
      }

      .modal-actions {
        padding: 16px 20px;
        background: #f8f9fa;
        border-top: 1px solid #e9ecef;
        display: flex;
        justify-content: center;

        .close-button {
          background: #4caf50;
          color: white;

          &:hover {
            background: #45a049;
          }
        }
      }
    `
  ]
})
export class SuccessModalComponent {
  private readonly dialogRef = inject(MatDialogRef<SuccessModalComponent>);
  public readonly data = inject(MAT_DIALOG_DATA) as {
    title?: string;
    message: string;
  };

  onClose(): void {
    this.dialogRef.close();
  }
}
